/// <reference types="gapi.youtube" />
import { removeUndefinedValues, convertISO8601ToMMSS, convertISO8601ToSS, } from '@wix/wix-vod-shared/common';
import { TRANSCODING_STATUSES, VIDEO_SOURCES, FREE_VIDEO_DEAL_INFO, } from '@wix/wix-vod-constants/common';
import getThumbnail from './get-thumbnail';
export const parseYoutubeVideo = (videoData) => {
    const { player = {}, snippet = {}, contentDetails = {} } = videoData;
    const { id: maybeExternalId } = videoData;
    const { embedHtml } = player;
    const { channelId, title, description, thumbnails, tags, category, publishedAt, } = snippet;
    const { duration, videoId } = contentDetails;
    const widthMatch = embedHtml ? embedHtml.match(/width="(\d+)/) : undefined;
    const heightMatch = embedHtml ? embedHtml.match(/height="(\d+)/) : undefined;
    const width = widthMatch ? Number(widthMatch[1]) : undefined;
    const height = heightMatch ? Number(heightMatch[1]) : undefined;
    const categories = (category ? [category] : []);
    let externalId = maybeExternalId;
    // >_<
    if (_.isObject(maybeExternalId)) {
        const { videoId: objectVideoId } = maybeExternalId;
        externalId = objectVideoId;
    }
    externalId = externalId || videoId;
    const mediaExternUrl = `//www.youtube.com/embed/${externalId}`;
    const coverUrl = getThumbnail(thumbnails);
    let durationSec = 0;
    let durationStr = '00:00';
    if (duration && duration !== 'P0D') {
        durationSec = convertISO8601ToSS(duration);
        durationStr = convertISO8601ToMMSS(duration);
    }
    const partialYoutubeVideo = removeUndefinedValues({
        coverUrl,
        width,
        height,
        channelId,
        durationSec,
        durationStr,
    });
    return {
        ...partialYoutubeVideo,
        externalId: externalId,
        description: description ?? '',
        title: title ?? '',
        tags: tags || [],
        categories,
        mediaExternUrl,
        mediaStatus: TRANSCODING_STATUSES.READY,
        dealInfo: FREE_VIDEO_DEAL_INFO,
        videoSource: VIDEO_SOURCES.YOUTUBE,
        datePublish: publishedAt,
    };
};
//# sourceMappingURL=video.js.map